import { useEffect, useState } from 'react';

/**
 * True once the page has scrolled past `threshold`. Used to detach the sticky
 * header from the hero — it sits flush at rest and grows a rule and shadow only
 * when content is actually passing underneath it.
 *
 * The listener is passive and only ever flips a boolean, so it does not cause a
 * render per scroll event.
 */
export function useScrolled(threshold = 8) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > threshold;
      setScrolled((prev) => (prev === past ? prev : past));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
